/**
 * Suspense fallback for the lazily-loaded routes.
 *
 * Previously an empty `<div className="min-h-screen" />`, which on a slow
 * connection meant tapping a nav link produced a blank white screen with no
 * indication anything was happening — so visitors tapped again, and again.
 * A quiet, brand-coloured pulse is enough to say "this is loading".
 */
export function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="min-h-[60vh] flex items-center justify-center"
    >
      <span className="sr-only">Loading</span>
      <span className="flex items-center gap-1.5" aria-hidden="true">
        <span className="w-2 h-2 rounded-full bg-primary/70 animate-pulse [animation-delay:-0.3s]" />
        <span className="w-2 h-2 rounded-full bg-primary/70 animate-pulse [animation-delay:-0.15s]" />
        <span className="w-2 h-2 rounded-full bg-primary/70 animate-pulse" />
      </span>
    </div>
  )
}
